import { Nullable } from 'global';

import { TemplatesState } from '../ui/viewCard/types';
import { StageId, TemplatesResponse, ViewStage } from '../api';

export function templatesDataNormalizer(
  flows: { businessProcessFlowId: string; currentStage: Nullable<string> }[],
  templatesRes: TemplatesResponse
) {
  return templatesRes.bpf.templates.reduce<{
    templatesByFlowId: TemplatesState;
    flowDepartmentMap: Record<string, string>;
  }>(
    templatesById => {
      flows.forEach((flow, flowIndex) => {
        templatesRes.bpf.templates.forEach(({ templates }) => {
          const template = templates.find(template => template.businessProcessFlowId === flow.businessProcessFlowId);

          if (template) {
            const stages = template?.stages ?? [];

            templatesById.flowDepartmentMap[template.department.id] = template.businessProcessFlowId;

            templatesById.templatesByFlowId[template.businessProcessFlowId] = {
              ...template,
              stages: stages.reduce<Record<StageId, ViewStage>>((acc, stage, currentIndex) => {
                acc[stage.businessProcessFlowStageId] = {
                  ...stage,
                  isLastStage:
                    flowIndex === templatesRes.bpf.templates.length - 1 && stages.length - 1 === currentIndex,
                };
                return acc;
              }, {}),
            };
          }
        });
      });

      return templatesById;
    },
    { templatesByFlowId: {}, flowDepartmentMap: {} }
  );
}
